function bindCartDiscountEvents() {
  const discountForm = document.querySelector('.cart-discount__form');
  if (discountForm && !discountForm.classList.contains('cart-discount-bound')) {
    discountForm.classList.add('cart-discount-bound');
    discountForm.addEventListener('submit', async function(event) {
      event.preventDefault();

      const discountInput = this.querySelector('input[name="discount"]');
      if (!discountInput) return;

      const discountCode = discountInput.value.trim();
      if (!discountCode) return;

      const sectionId = this.getAttribute('data-section-id');
      if (!sectionId) return;

      const existingDiscounts = getExistingDiscounts();
      if (existingDiscounts.includes(discountCode)) return;

      hideError();

      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            discount: [...existingDiscounts, discountCode].join(','),
            sections: [sectionId]
          })
        });

        if (!response.ok) throw new Error('HTTP error! status: ' + response.status);

        const data = await response.json();
        
        if (data.token) {
          if (data.sections && data.sections[sectionId]) {
            const sectionEl = document.getElementById('shopify-section-' + sectionId);
            if (sectionEl) {
              sectionEl.outerHTML = data.sections[sectionId];
              bindCartDiscountEvents();
            }
          } else {
            window.location.reload();
          }
        } else {
          if (data.discount_codes && data.discount_codes.length > 0) {
            const invalidCode = data.discount_codes.find(discount => 
              discount.code === discountCode && discount.applicable === false
            );
            
            if (invalidCode) {
              discountInput.value = '';
              showError('İndirim kodu geçersiz veya uygulanamıyor');
              return;
            }
          }
          showError('İndirim kodu geçersiz veya uygulanamıyor');
        }
      } catch (error) {
        showError('Bir hata oluştu, lütfen tekrar deneyin');
      }
    });
  }

  document.querySelectorAll('.cart-discount__pill-remove').forEach(btn => {
    if (!btn.classList.contains('cart-discount-bound')) {
      btn.classList.add('cart-discount-bound');
      btn.addEventListener('click', function(event) {
        event.preventDefault();
        const pill = event.target.closest('.cart-discount__pill');
        if (pill) {
          const discountCode = pill.dataset.discountCode;
          if (discountCode) {
            removeDiscount(discountCode);
          }
        }
      });
    }
  });
}

function getExistingDiscounts() {
  const discountCodes = [];
  const discountPills = document.querySelectorAll('.cart-discount__pill');
  discountPills.forEach(pill => {
    if (pill.dataset.discountCode) {
      discountCodes.push(pill.dataset.discountCode);
    }
  });
  return discountCodes;
}

async function removeDiscount(discountCode) {
  const discountForm = document.querySelector('.cart-discount__form');
  if (!discountForm) return;
  const sectionId = discountForm.getAttribute('data-section-id');
  if (!sectionId) return;

  const existingDiscounts = getExistingDiscounts();
  const index = existingDiscounts.indexOf(discountCode);
  if (index > -1) {
    existingDiscounts.splice(index, 1);
  }

  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        discount: existingDiscounts.join(','),
        sections: [sectionId]
      })
    });

    if (response.ok) {
      const data = await response.json();
      if (data.sections && data.sections[sectionId]) {
        const sectionEl = document.getElementById('shopify-section-' + sectionId);
        if (sectionEl) {
          sectionEl.outerHTML = data.sections[sectionId];
          bindCartDiscountEvents();
        }
      }
    }
  } catch (error) {
    showError('İndirim kaldırılırken bir hata oluştu');
  }
}

function showError(message) {
  const errorElement = document.querySelector('.cart-discount__error');
  const errorTextElement = document.querySelector('.cart-discount__error-text');
  if (errorElement && errorTextElement) {
    errorElement.classList.remove('hidden');
    errorTextElement.classList.remove('hidden');
    errorTextElement.textContent = message;
  }
}

function hideError() {
  const errorElement = document.querySelector('.cart-discount__error');
  const errorTextElement = document.querySelector('.cart-discount__error-text');
  if (errorElement && errorTextElement) {
    errorElement.classList.add('hidden');
    errorTextElement.classList.add('hidden');
  }
}

document.addEventListener('DOMContentLoaded', bindCartDiscountEvents);
